import React, { useEffect, useState } from "react";
import { useTheme } from "../ThemeProvider";
import { useParams, useLocation } from "react-router-dom";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import Header from "../components/header/mainHeader.js";
import Footer from "../components/footer/mainFooter.js";
import axios from "axios";
import NavbarSection from "../components/NavBar/Navbar.js";
import FooterSection from "../components/NewFooter/Footer.js";

function MysteryBox() {
  const { theme } = useTheme();
  const location = useLocation();
  const { boxId, userId } = useParams();
  const [visited, setVisited] = useState(false);
  const db = getFirestore();

  document.title = "3VO | Mystery Box";

  useEffect(() => {
    const timer = setTimeout(() => {
      handleVisitClick();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (visited) {
      const queryParams = new URLSearchParams(location.search);
      let targetUrl = queryParams.get("target");

      if (targetUrl) {
        if (
          !targetUrl.startsWith("http://") &&
          !targetUrl.startsWith("https://")
        ) {
          targetUrl = `https://${targetUrl}`;
        }

        window.location.href = targetUrl;
      }
    }
  }, [visited, location]);

  const handleVisitClick = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      const ipAddress = response.data.ip;

      const visitDocRef = doc(db, "visits", `${boxId}_${userId}`);
      const visitDoc = await getDoc(visitDocRef);

      if (!visitDoc.exists()) {
        await setDoc(visitDocRef, {
          userId: userId,
          boxId: boxId,
          timestamp: new Date().toISOString(),
          visited: true,
          ipAddress: ipAddress,
        });
      }

      setVisited(true);
    } catch (error) {
      console.error("Error storing visit data in Firestore:", error);
    }
  };

  return (
    <div className={`subpage ${theme === "light" ? "" : "dark-theme"}`}>
      {/* <Header /> */}
      <NavbarSection />
      <div className="redirect-page">
        <button
          className="callToAction-action-button2"
          onClick={handleVisitClick}
        >
          Visit now
        </button>
        <div className="redirect-image" />
        <div className="redirect-button"></div>
      </div>
      <FooterSection />
    </div>
  );
}

export default MysteryBox;
